import { useAppSelector } from "../store/index.ts";

export default function useNickname() {
  const login = useAppSelector((state) => state.user.info.login);
  const telegramName = useAppSelector((state) => state.user.info.telegramName);
  const email = useAppSelector((state) => state.user.info.email);
  const nickname = email || telegramName || login || "Nickname";
  const isPhone = /^[+\d]/.test(nickname);
  return nickname.includes("@") || isPhone ? nickname : `@${nickname}`;
}
